import React, { useEffect, useState } from 'react';
import { utility } from '../../framework/utility/utilityProvider';
import { MEDIACATEGORIES } from '../../framework/constant/constant';
import SeriesTimeLineTile from './SeriesTimeLineTile';

const SeriesGantView = ({
    data = [],
    channel,
    startDateTime,
    endDateTime,
    timeSlots,
    setTimeSlots,
    slotDuration = 60,
    selectedView = 'week'
}) => {

    const [timeLineViewData, setTimeLineViewData] = useState([]);
    const [weeklySlots, setWeeklySlots] = useState([]);

    useEffect(() => {
        let tempData = [];

        if (timeSlots && timeSlots.length > 0) {
            timeSlots.map((timeSlot) => {
                let item = { timeRange: timeSlot };

                if (data && Object.keys(data).length > 0) {
                    Object.keys(data).map((key) => {
                        let recursiveItems = data[key];

                        let timeSlotInMilliseconds = utility.convertStringWithFramesToMilliseconds(`${timeSlot.label}:00:00`);

                        if (
                            timeSlotInMilliseconds >= utility.convertStringWithFramesToMilliseconds(utility.convertMilisecondsToStringWithFrames(recursiveItems[0]?.SlotDateTime)) &&
                            timeSlotInMilliseconds <= utility.convertStringWithFramesToMilliseconds(utility.convertMilisecondsToStringWithFrames(recursiveItems[0]?.SlotDateTime))
                        ) {
                            item = { ...item, series: recursiveItems };
                        }
                    });
                }

                tempData.push(item);
            });
        }

        setTimeLineViewData(tempData);
    }, []);

    const generateTimeSlots = (start, end, view) => {
        const slots = [];
        let current = new Date(start);

        const formatDate = (date) =>
            date.toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
            }).replace(/ /g, '-');

        if (view === 'week') {
            const dayOffset = (current.getDay() + 6) % 7;
            current.setDate(current.getDate() - dayOffset);

            while (current <= end) {
                const weekStart = new Date(current);
                const weekEnd = new Date(current);
                weekEnd.setDate(weekEnd.getDate() + 6);

                slots.push({
                    label: `${formatDate(weekStart)} - ${formatDate(weekEnd)}`,
                    start: new Date(weekStart),
                    end: new Date(weekEnd)
                });

                current.setDate(current.getDate() + 7);
            }
        } else {
            while (current <= end) {
                const dayStart = new Date(current);
                slots.push({
                    label: formatDate(dayStart),
                    start: new Date(dayStart),
                    end: new Date(dayStart)
                });

                current.setDate(current.getDate() + 1);
            }
        }

        return slots;
    };

    useEffect(() => {
        const newSlots = generateTimeSlots(new Date(startDateTime), new Date(endDateTime), selectedView);
        setWeeklySlots(newSlots);
    }, [selectedView, startDateTime, endDateTime]);

    let timeLineIndex = -5;

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-body p-0 border" style={{ maxHeight: '76.5vh', overflow: 'auto' }}>
                            <table className="table table-bordered mb-0 border">
                                <thead className="border">
                                    <tr className="border">
                                        <th
                                            className="border"
                                            colSpan={weeklySlots.length + 1}
                                            style={{
                                                textAlign: 'center',
                                                backgroundColor: '#f8f9fa',
                                                position: 'sticky',
                                                top: 0,
                                                zIndex: 6,
                                                padding: '5px',
                                                fontSize: '15px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {channel?.FullChannelName ?? "Series Timeline Overview"}
                                        </th>
                                    </tr>

                                    <tr className="border">
                                        <th
                                            className="border"
                                            style={{
                                                position: 'sticky',
                                                backgroundColor: '#fff',
                                                zIndex: 5,
                                                top: 40,
                                                width: '30px',
                                                minWidth: '30px',
                                                maxWidth: '30px',
                                                textAlign: 'center'
                                            }}
                                        >
                                            Time
                                        </th>
                                        {weeklySlots.map((slot, index) => (
                                            <th
                                                className="border"
                                                style={{
                                                    position: 'sticky',
                                                    top: 40,
                                                    backgroundColor: '#fff',
                                                    zIndex: 4,
                                                    width: '200px',
                                                    minWidth: '200px',
                                                    maxWidth: '200px',
                                                    textAlign: 'center'
                                                }}
                                                key={`time-${index}`}
                                            >
                                                {slot.label}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="border">
                                    {timeLineViewData && timeLineViewData.length > 0 && timeLineViewData.map((event, index) => {

                                        const startTime = !event.series || event.series.length === 0 ? null : new Date(utility.convertMilisecondsToDateString(event?.series[0]?.SlotDateTime));
                                        const endTime = !event.series || event.series.length === 0 ? null : new Date(utility.convertMilisecondsToDateString(event?.series[event.series.length - 1]?.SlotDateTime));

                                        return (
                                            <tr key={index} style={{ height: '90px' }}>
                                                <td className="border text-center" style={{ fontWeight: "bold", fontSize: '14px' }}>
                                                    {utility.subString(event?.timeRange.label, 40)}
                                                </td>

                                                {weeklySlots.map((slot, slotIndex) => {

                                                    return (
                                                        < SeriesTimeLineTile
                                                            timeLineIndex = {timeLineIndex++}
                                                            slotDuration = {slotDuration}
                                                            index = {index}
                                                            slotIndex = {slotIndex}
                                                            startTime = {startTime} 
                                                            endTime = {endTime} 
                                                            slot = {slot} 
                                                            event = {event} 
                                                            selectedView = {selectedView}
                                                        />
                                                    )
                                                })}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SeriesGantView;
